import React from "react";

const About = () => (
  <div>
    <h2> About Me </h2>
    <div> I've been a web developer since 1932 </div>
  </div>
);

export default About;



// WEBPACK FOOTER //
// ./src/About.js